interface UtilitySidebarProps {
  activeSection: string
  setActiveSection: (s: string) => void
}

const sections = [
  {
    id: 'keyword-planner',
    name: 'Keyword Planning',
    icon: 'ri-search-line',
    items: [{ id: 'keyword-planner', name: 'Keyword Planner', icon: 'ri-keyboard-line' }],
  },
  {
    id: 'brand-equity',
    name: 'Brand Equity',
    icon: 'ri-bar-chart-grouped-line',
    items: [{ id: 'brand-equity', name: 'Dashboard', icon: 'ri-dashboard-line' }],
  },
]

export default function UtilitySidebar({ activeSection, setActiveSection }: UtilitySidebarProps) {
  return (
    <div className="w-64 bg-white border-r border-gray-200 h-full flex flex-col flex-shrink-0">
      <div className="p-6 border-b border-gray-200">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-gradient-to-br from-teal-400 to-teal-600 rounded-lg flex items-center justify-center">
            <span className="text-white font-bold text-lg">4</span>
          </div>
          <div>
            <h1 className="text-lg font-bold text-gray-900">4sight</h1>
            <p className="text-xs text-gray-500">Utility Manager</p>
          </div>
        </div>
      </div>

      <nav className="flex-1 p-4 overflow-y-auto">
        <div className="space-y-2">
          {sections.map((section) => (
            <div key={section.id}>
              <button
                onClick={() => setActiveSection(section.items[0].id)}
                className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-lg transition-colors text-left ${
                  section.items.some((i) => i.id === activeSection)
                    ? 'bg-gray-100 text-gray-900'
                    : 'text-gray-600 hover:bg-gray-100'
                }`}
              >
                <i className={`${section.icon} text-lg w-5 h-5 flex items-center justify-center`} />
                <span className="font-medium text-sm">{section.name}</span>
              </button>
            </div>
          ))}
        </div>
      </nav>
    </div>
  )
}
